
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { PlusCircle } from 'lucide-react';

const CreateFreeAd = () => {
  const navigate = useNavigate();

  const handleCreateListing = () => {
    navigate('/create-listing');
  };

  return (
    <section className="py-8">
      <div className="bg-gradient-to-r from-green-50 to-green-100 rounded-xl p-8 text-center">
        <h2 className="text-2xl font-bold mb-4">Krijoni një shpallje falas</h2>
        <p className="text-gray-600 mb-6 max-w-md mx-auto">
          Shitni produktet tuaja në mënyrë të shpejtë dhe pa kosto shtesë në platformën tonë
        </p>
        <Button 
          onClick={handleCreateListing}
          size="lg" 
          className="bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-8 rounded-full shadow-lg transform transition-transform hover:scale-105"
        >
          <PlusCircle size={20} className="mr-2" />
          Krijo Shpallje Falas
        </Button>
      </div>
    </section>
  );
};

export default CreateFreeAd;
